export enum ApplicationsTabEnumEnum {
  Contracts = 'Contracts',
  Current = 'Current',
}
